<template>
  <div id="bst-wrap">
    <div class="l-project-wrap l-project-wrap--top">

      <header class="l-header l-header--top">
        <public-page-header />
      </header>


      <!-- MAIN -->
      <section class="p-top l-top__outer">
        <div class="p-top__wrap">

          <div class="p-top__head">
            <h1 v-html="$t('TEXT_INDEX_HEADER')"></h1>
            <p v-html="$t('TEXT_INDEX_1')"></p>
          </div>

          <div class="p-top__bloc p-top__bloc--personal">
            <div class="p-top-bloc__txt">
              <h3>for Personal</h3>
              <h2>{{ $t('TEXT_INDEX_2') }}</h2>
              <p>{{ $t('TEXT_INDEX_3') }}</p>
              <ul>
                <li>{{ $t('TEXT_INDEX_4') }}</li>
                <li>{{ $t('TEXT_INDEX_5') }}</li>
                <li>{{ $t('TEXT_INDEX_6') }}</li>
                <li v-html="$t('TEXT_INDEX_7')"></li>
              </ul>
              <div class="c-btn c-btn--top-bloclink"><router-link id="link-login-2" :to="{ name: 'login' }">{{
                $t('LABEL_MY_PAGE') }}</router-link></div>
            </div>
            <div class="p-top-bloc__img">
              <img src="@/assets/img/top/img_personal.jpg" :alt="$t('TEXT_INDEX_2')">
            </div>
          </div>

          <div class="p-top__bloc p-top__bloc--business">
            <div class="p-top-bloc__txt">
              <h3>for Business</h3>
              <h2 v-html="$t('TEXT_INDEX_8')"></h2>
              <p v-html="$t('TEXT_INDEX_9')"></p>
              <div class="c-btn c-btn--top-bloclink"><router-link :to="{ name: 'contact.us' }">{{
                $t('LABEL_CONTACT_US') }}</router-link>
              </div>
            </div>
            <div class="p-top-bloc__img">
              <img src="@/assets/img/top/img_business.jpg" :alt="$t('LABEL_MERCHANT_ACCOUNT')">
            </div>
          </div>

          <!-- <div class="p-top__bloc p-top__bloc--registration">
            <div class="p-top-registration__txt">
              <h2>{{ $t('TEXT_INDEX_10') }}</h2>
              <div class="c-btn c-btn--top-registration"><router-link id="link-registration-2"
                  :to="{ name: 'register.agreement' }">{{ $t('TEXT_INDEX_11') }}</router-link></div>
            </div>
          </div> -->
        </div>
      </section>

    </div><!-- .l-project-wrap--top -->

    <PublicFooter/>

  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { initializeTop } from "@/assets/js/entries/top.js";
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import PublicFooter from "@/components/PublicFooter.vue";

onMounted(() => {
    initializeTop();
})
</script>